import Resources from '@/Resources';
import Config from '@/Config';
import { platform } from '@/Models';

export const pageNavigationTypes = {
    platform: 'platform',
    creator: 'creator',
    system: 'system',
    special: 'special',
};

const allPlatforms = [platform.gamefound, platform.ideafound];

const buildPagesNavigationItem = ({
    key,
    name,
    url,
    isFeatured = false,
    isEnabled = true,
    pageNavigationType = pageNavigationTypes.platform,
    platformType = allPlatforms,
    onAction = () => {},
}) => {
    let enabled = isEnabled;

    if (!name || !url) {
        enabled = false;
    }

    const navigationItem = {
        url,
        name,
        isFeatured,
        isEnabled: enabled,
        pageNavigationType,
        platformType,
        onAction,
    };

    if (key) {
        navigationItem.key = key;
    }

    return navigationItem;
};

const isNavigationItemVisible = (item) =>
    item.isEnabled && item.platformType.includes(Config.platform);

export function usePagesNavigation() {
    const navigationItems = [
        buildPagesNavigationItem({
            key: 'AboutUs',
            url: Config.navigation.aboutUsUrl,
            name: Resources.Layout.AboutUsLink,
            platformType: [platform.gamefound],
        }),
        buildPagesNavigationItem({
            key: 'WhyGamefound',
            url: Config.navigation.whyGamefoundUrl,
            name: Resources.Layout.WhyGamefoundLink,
            platformType: [platform.gamefound],
        }),
        buildPagesNavigationItem({
            key: 'Contact',
            url: Config.navigation.contactUrl,
            name: Resources.Layout.ContactLink,
        }),
        buildPagesNavigationItem({
            key: 'CrowdfundingGuide',
            url: Config.navigation.crowdfundingGuideUrl,
            name: Resources.Layout.CrowdfundingGuideLink,
        }),
        buildPagesNavigationItem({
            key: 'Career',
            url: Config.externalUrls.careerUrl,
            name: Resources.Layout.CareerLink,
            platformType: [platform.gamefound],
        }),
        buildPagesNavigationItem({
            key: 'Fees',
            url: Config.navigation.feesUrl,
            name: Resources.Layout.FeesLink,
            pageNavigationType: pageNavigationTypes.creator,
        }),
        buildPagesNavigationItem({
            key: 'MarketingServices',
            url: Config.navigation.marketingServicesUrl,
            name: Resources.Layout.MarketingServicesLink,
            pageNavigationType: pageNavigationTypes.creator,
        }),
        buildPagesNavigationItem({
            key: 'PerformanceMarketing',
            url: Config.navigation.performanceMarketingUrl,
            name: Resources.Layout.PerformanceMarketingLink,
            isFeatured: true,
            isEnabled: Config.siteFeatures.performanceMarketingEnabled,
            pageNavigationType: pageNavigationTypes.creator,
            platformType: [platform.gamefound],
        }),
        buildPagesNavigationItem({
            key: 'BecomeACreator',
            url: Config.navigation.becomeACreatorUrl,
            name: Resources.Layout.BecomeACreatorLink,
            isFeatured: true,
            pageNavigationType: pageNavigationTypes.creator,
        }),
        buildPagesNavigationItem({
            key: 'Blog',
            url: Config.navigation.blogUrl,
            name: Resources.Layout.BlogLink,
            pageNavigationType: pageNavigationTypes.creator,
        }),
        buildPagesNavigationItem({
            key: 'PrivacyPolicy',
            url: Config.navigation.privacyPolicyUrl,
            name: Resources.Layout.PrivacyPolicyLink,
            pageNavigationType: pageNavigationTypes.system,
        }),
        buildPagesNavigationItem({
            key: 'ToS',
            url: Config.navigation.termsOfServiceIndexUrl,
            name: Resources.Layout.TermsOfServiceLink,
            pageNavigationType: pageNavigationTypes.system,
        }),
        buildPagesNavigationItem({
            key: 'CookieSettings',
            url: Config.navigation.cookieSettingsUrl,
            name: Resources.Layout.CookieSettingsLink,
            pageNavigationType: pageNavigationTypes.system,
            platformType: [platform.gamefound],
        }),
        buildPagesNavigationItem({
            key: 'PrivacySettings',
            url: Config.navigation.cookieSettingsUrl,
            name: Resources.Layout.PrivacySettingsLink,
            pageNavigationType: pageNavigationTypes.system,
            platformType: [platform.ideafound],
            onAction: (event) => {
                if (Config.siteFeatures.transcendIntegrationEnabled && window.transcend) {
                    event.preventDefault();
                    window.transcend.showConsentManager();
                }
            },
        }),
        buildPagesNavigationItem({
            key: 'Help',
            url: Config.externalUrls.helpUrl,
            name: Resources.Layout.HelpLink,
            pageNavigationType: pageNavigationTypes.creator,
        }),
        buildPagesNavigationItem({
            key: 'WeDoNotSellYourData',
            url: Config.navigation.privacyPolicyUrl,
            name: Resources.Layout.WeDoNotSellYourDataLink,
            pageNavigationType: pageNavigationTypes.special,
            platformType: [platform.ideafound],
        }),
    ];

    return {
        navigationItems: navigationItems.filter(isNavigationItemVisible),
        navigationItemTypes: pageNavigationTypes,
        platformTypes: platform,
    };
}
